module.exports = __webpack_public_path__ + "static/media/helsinki-festival-logo-grey.566505e7.svg";